import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "@/store";
import { ThemeProvider } from "@/theme/ThemeContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { AuthInit } from "@/components/auth/AuthInit";
import { router } from "@/router";
import "@/i18n";

export function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <NotificationProvider>
          <AuthInit>
            <RouterProvider router={router} />
          </AuthInit>
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  );
}
